import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var fontSizes = [
    "xxxl",
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs",
    "xxs",
];
var Text = function (_a) {
    var id = _a.id, as = _a.as, _b = _a.component, component = _b === void 0 ? "span" : _b; _a.bold; var crop = _a.crop, _c = _a.align, align = _c === void 0 ? "left" : _c, _d = _a.size, size = _d === void 0 ? "md" : _d, _e = _a.tone, tone = _e === void 0 ? "dark" : _e, truncate = _a.truncate, children = _a.children, _f = _a.font, font = _f === void 0 ? "body" : _f, sx = _a.sx, props = __rest(_a, ["id", "as", "component", "bold", "crop", "align", "size", "tone", "truncate", "children", "font", "sx"]);
    var _g = useTheme(), applyTheme = _g.applyTheme, textCrop = _g.textCrop;
    var isUsingFont = font !== "body";
    var cropTextStyles = function () {
        // we need the font line height to select the right crop
        // convert font to it's parts
        var lineHeight = applyTheme({ font: font || size }).lineHeight;
        // convert lineHeight index to scale value
        (lineHeight = applyTheme({ lineHeight: lineHeight }).lineHeight);
        return textCrop({ lineHeight: Number(lineHeight) });
    };
    var toneMap = {
        dark: "text-main",
        light: "white",
        subtle: "text-secondary",
        critical: "feedback-error-foreground",
    };
    return (jsx(Box, __assign({ id: id, as: as || component, sx: __assign(__assign(__assign({ font: isUsingFont ? font : size, display: "block", boxSizing: "border-box", color: toneMap[tone], textAlign: align }, (crop && cropTextStyles())), (truncate && {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        })), sx) }, props, { children: children })));
};

export { Text, fontSizes };
//# sourceMappingURL=Text.js.map
